// Minimal localStorage wrapper; storage can be unavailable or throw (private mode, blocked site data)
export default {
    get(key) {
        try {
            return window.localStorage.getItem(key);
        } catch (e) {
            return null;
        }
    },
    set(key, value) {
        try {
            window.localStorage.setItem(key, value);
        } catch (e) {}
    },
    remove(key) {
        try {
            window.localStorage.removeItem(key);
        } catch (e) {}
    }
};
